import styled from 'styled-components'
import tw from 'twin.macro'

export const BreadcrumbWrapper = styled.div`
  ${tw`ta-max-width-parent px-3 md:px-4`};
`
